// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"525":"6457ca67","787":"8b2f006b","861":"0a18af2f","875":"d6f05358","896":"e899974a"}[chunkId] + ".chunk.js";
};